module.exports = __webpack_public_path__ + "media/images/landing/persons/marketa-zvolska-bee984325ca9a33100f73d569d9249b6.jpg";